<template>
    <loading name="load home">
        <div class="index">
            <Carousel/>
            <div class="container main-container padding-bottom pt-3 col-10">
                <h3 class="text-uppercase">{{ $t('pages.Home') }}</h3>
                <div class="row main-content">
                    <div class="col-md-8">
                        <last-featured-item :last-featured-news="latestFeaturedNews"/>
                    </div>
                    <div class="col-md-4 right-panel margin-lg-top">
                        <home-side-panel :latest-news="latestNews" :most-viewed-news="mostViewedNews"/>
                    </div>
                    <featured-news :news="featuredNews"/>
                </div>
                <span class="add" v-if="user.editor || user.admin">
                    <span class="dropup edit-dropdown">
                        <a href="#" data-toggle="dropdown"
                           role="button" aria-expanded="false"
                           aria-haspopup="true"
                           class="dropdown-toggle">
                            <span class="circle text-center">
                                <i class="fas fa-plus"></i>
                            </span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                            <router-link to="/news/create" class="dropdown-item">{{ $t('button.NewNews') }}</router-link>
                            <router-link to="/news-list/unpublished" class="dropdown-item">{{ $t('button.UnpublishedNews') }}</router-link>
                            <router-link to="/images" class="dropdown-item">{{ $t('button.CreateEditImages') }}</router-link>
                        </div>
                    </span>
                </span>
            </div>
        </div>
    </loading>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import Carousel from '../components/home/Carousel.vue';
  import HomeSidePanel from '../components/home/HomeSidePanel';
  import LastFeaturedItem from '../components/home/LastFeaturedItem';
  import FeaturedNews from '../components/home/FeaturedNews';
  import api from '../api';

  export default {
    name: 'home',
    components: {
      FeaturedNews,
      LastFeaturedItem,
      HomeSidePanel,
      Carousel
    },
    methods: {
      ...mapActions(['loadActiveSliderImages', 'loadAvailableEvents']),
    },
    computed: {
      ...mapGetters(['user']),
      page() {
        const page = this.$route.query.p;
        return page && !isNaN(parseInt(page)) ? parseInt(page) : 1;
      }
    },
    data() {
      return {
        latestFeaturedNews: {},
        featuredNews: [],
        latestNews: {},
        mostViewedNews: {}
      }
    },
    created() {
      this.$wait.start('load home');

      const latestFeaturedNews = api.news.featured({
        page: 1,
        size: 1,
        offset: 0
      });

      const news = api.news.featured({
        page: this.$route.query.p || 1,
        size: 3
      });

      const image = this.loadActiveSliderImages();

      const latest = api.news.list();
      const best = api.news.mostViewed();


      const events = this.loadAvailableEvents();

      Promise.all([image, news, latestFeaturedNews, latest, best, events])
        .then((data) => {
          this.featuredNews = data[1];
          this.latestFeaturedNews = data[2];
          this.latestNews = data[3];
          this.mostViewedNews = data[4];
          this.$wait.end("load home");
        });
    },
    watch: {
      page() {
        const page  = this.$route.query.p ? parseInt(this.$route.query.p.toString()) : 1;

        api.news.featured({
          page: page,
          size: 3
        }).then((data) => {
          this.featuredNews = data
        })
      }
    }
  };
</script>
